<template>
  <div class="content conmon-top">
      <el-row class="sn-manage-top">
          <el-col :span="5">
              本次活动奖品总数：<span>{{dataCount}}</span>个
          </el-col>
          <el-col :span="5" :gutter="20">
              中奖人数：{{recordCount}}个
          </el-col>
          <el-col :span="5" :gutter="20">
              已发奖品： {{sendCount}}个
          </el-col>
      </el-row>
      <el-row class="import-data-title" style="margin-top: 10px">
          <el-table
                  :data="tableData"
                  border
                  style="width: 100%"
                  class="table">
              <el-table-column
                      prop="id"
                      label="序号"
                      width="100">
              </el-table-column>
              <el-table-column
                      prop="sn"
                      label="SN码(中奖号)"
                      width="150">
              </el-table-column>
              <el-table-column
                      prop="prize"
                      label="奖项"
                      width="100">
              </el-table-column>
              <el-table-column
                      prop="prizeName"
                      label="奖品"
                      width="100">
              </el-table-column>
              <el-table-column
                      label="是否已发放奖品"
                      width="">
                  <template slot-scope="scope">
                      <span v-if="scope.row.sendstutas !== 1">未发奖</span>
                      <span v-else>已发奖</span>
                  </template>
              </el-table-column>
              <el-table-column
                      prop="sendtime"
                      label="奖品发送时间"
                      width="">
                  <template slot-scope="scope">
                      {{ scope.row.sendtime | formatDate }}
                  </template>
              </el-table-column>
              <el-table-column
                      prop="phone"
                      label="中奖者手机号"
                      width="">
              </el-table-column>
              <el-table-column
                      prop="wecha_name"
                      label="中奖者微信号"
                      width="">
              </el-table-column>
              <el-table-column
                      prop="time"
                      label="中奖时间"
                      width="">
                  <template slot-scope="scope">
                      {{ scope.row.time | formatDate }}
                  </template>
              </el-table-column>
              <el-table-column label="操作" width="" style="display: flex;justify-content: center">
                  <template slot-scope="scope">
                      <div class="op-link" style="margin:0 10px;">
                         <span v-if="scope.row.sendstutas !== 1" @click="send(scope.row.id)">发奖</span>
                         <span v-else @click="cancel(scope.row.id)">取消发奖</span>
                          <span @click="deleteAction(scope.row.id)">删除</span>
                      </div>
                  </template>
              </el-table-column>
          </el-table>
          <div class="table-foot">
              <el-pagination
                      class="table-foot-pagination"
                      background
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :page-size="limit"
                      layout="total, prev, pager, next, jumper"
                      :total="totalCount">
              </el-pagination>
          </div>
      </el-row>
  </div>
</template>
<script>
import { getSNlist, deleteSnManage, sendPrize, cancelPrize } from '@/api/customer.js'
export default {
  name: 'sn-manage',
  data () {
    return {
      tableData: [],
      dataCount: '',
      sendCount: '',
      recordCount: '',
      page: 1,
      limit: 10,
      totalCount: 0
    }
  },
  methods: {
    // 兑奖
    send(id) {
      this.$confirm('确认要开始发奖?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        sendPrize(id).then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', '发奖成功')
            this.load()
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
      })
    },
    cancel(id) {
      this.$confirm('确认要取消发奖?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        cancelPrize(id).then((res) => {
          if (res.data.code === 0) {
            this.load()
            _g.toastMsg('success', '取消兑奖成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
      })
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.load()
    },
    handleCurrentChange(page) {
      this.page = page
      this.load()
    },
    load() {
      let id = this.$route.query.id
      getSNlist(id, this.page, this.limit).then(res => {
        if (res.data.code === 0) {
          this.sendCount = res.data.data.sendCount
          this.dataCount = res.data.data.dataCount
          this.recordCount = res.data.data.recordCount
          this.tableData = res.data.data.list
          this.totalCount = res.data.data.total
        }
      })
    },
    deleteAction(id) {
      this.$confirm('确认删除该SN码?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSnManage(id).then((res) => {
          if (res.data.code === 0) {
            this.load()
            _g.toastMsg('success', 'SN码删除成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
      })
    }
  },
  created() {
    this.load()
  },
  components: {
  }
}
</script>

<style scoped>
  .sn-manage-top{
      background-color: #fefbe4;
      border:1px solid #f3ecb9;
      color:#993300;
      height:42px;
      line-height: 42px;
      margin-bottom: 5px;
  }
</style>
